import { POST, GET } from "./utils";

export const createRapidWorkflow = async (data: any) => {
    return await POST("/api/workflow", data);
};

export const getRapidWorkflow = async (workflowUrl: string, workspaceId: string) => {
    return await GET(`/api/workflow/${workflowUrl}?workspaceId=${workspaceId}`);
};

export const getPublicRapidWorkflowBySlug = async (shareableSlug: string) => {
    return await GET(`/api/workflow/public/${shareableSlug}`);
};

export const getWorkflowToken = async (workflowId: string, workspaceId: string) => {
    return await GET(`/query/workflow/token?workflowId=${workflowId}&workspaceId=${workspaceId}`);
};

export const getPublicRapidData = async (rapidDataId: string) => {
    return await GET(`/api/rapiddata/public/${rapidDataId}`);
};

export const getWorkspaceRapidModels = async (workspaceId: string) => {
    return await GET(`/api/workspace/${workspaceId}/models`);
};
